import { ProcedureTypeAttachmentService as OvermapProcedureTypeAttachmentService } from "@overmap-ai/core"

import type { RootState } from "../../store"
import type { AppSDK } from "../sdk"

export class ProcedureTypeAttachmentService extends OvermapProcedureTypeAttachmentService<RootState, AppSDK> {
	host = import.meta.env.REACT_APP_API_URL
}
